import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of, forkJoin } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {
  ModalService,
  BannerData,
  SectionCardSaudeData,
  CardData,
  TaxData,
  Step,
} from '@fcp/lib-ui';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';

// tslint:disable-next-line: nx-enforce-module-boundaries
import { HttpClientService } from 'apps/portal/src/app/essentials/http/http-client.service';
// tslint:disable-next-line: nx-enforce-module-boundaries
import { CMSSessionService } from 'apps/portal/src/app/essentials/cms/session/cms-session.service';
import { OverlayService } from '../../../shared/overlay/overlay.service';
import { IPService } from '../../../essentials/ip/ip.service';

import { CookieService } from 'ngx-cookie-service';

// tslint:disable-next-line: nx-enforce-module-boundaries
import { environment } from 'apps/portal/src/environments/environment';
// tslint:disable-next-line: nx-enforce-module-boundaries
import { getQuery } from 'apps/portal/src/app/essentials/cms/graphql/dynamic-table.model';

@Injectable({
  providedIn: 'root',
})
export class DynamicTablePreviewService extends HttpClientService {
  public host = environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(
    private router: Router,
    public http: HttpClient,
    private cmsSessionService: CMSSessionService,
  ) {
    super(http);
  }

  public preview(schema: string, params?: any): Observable<any> {
    const url = this.host + schema;
    const token = this.cmsSessionService.getToken();

    return this.post(url, params, 'preview', token);
  }

  public getQuery(id: string) {
    const schema = 'graphql';
    const params = {
      query: getQuery(id),
    };

    const url = this.host + schema;
    const token = this.cmsSessionService.getToken();

    return this.preview('graphql', params).pipe(
      map(response => {
        const items = response.body.data.queryTabelasDinamicasContents[0];
        if (items.flatDataDraft) {
          return items.flatDataDraft;
        }
        return items;
      }),
      catchError(error => {
        if (!environment.production) {
          console.log(error);
        }
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }
}
